<template>
<nav>
  <v-dialog
    v-if="!dialogVisibleAddAttachment && !dialogVisibleAddLink"
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    data-testid="dialog"
    scrollable
    ref="dialog"
    content-class="content-create-template-dialog-hub"
    @click:outside="closeDialog"
  >
    <v-card  color="background" style="margin-top:-72px">
      <v-card-text  ref="content" class="pa-0">
       <div class="fill-height ">
            <v-navigation-drawer
              v-model="drawer"
              overlay-opacity="1"
              hide-overlay
              clipped
              color="background"
              fluid
              data-testid="navigation-drawer"
              style="z-index: 6;width:100%;"
              disable-resize-watcher
              stateless
              class="areaNavBar"
              
            >
      <v-row
        no-gutters
        style="position:relative;top:72px;z-index:1"
      >
        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none ma-6"
          @click="show=false"
        >
          mdi-close
        </v-icon>
      </v-row>
   
      <v-row no-gutters >
        <v-col
          class="pa-1"
          align="center"
          cols="4"
        >
          <AddContentInHub
            data-testid="add-activities"
            :page-title="$t('addContentInHubTitleActivities')"
            :page-text="$t('addContentInHubTextActivities')"
            page-image="create-activity"
            :page-create-btn="$t('add')"
            @proceedSubmit="addActivites"
          />
        </v-col>
         <v-col
          class="py-1 px-0"
          align="center"
          cols="4"
        >
          <AddContentInHub
            data-testid="add-attachment"
            :page-title="$t('addContentInHubTitleAttachment')"
            :page-text="$t('addContentInHubTextAttachment')"
            page-image="attachment"
            :page-create-btn="$t('add')"
            @proceedSubmit="addAttachment"
          />
        </v-col>
        <v-col
          class="pa-1"
          align="center"
          cols="4"
        >
          <AddContentInHub
            data-testid="add-link"
            :page-title="$t('addContentInHubTitleLink')"
            :page-text="$t('addContentInHubTextLink')"
            page-image="link"
            :page-create-btn="$t('add')"
            @proceedSubmit="addLink"
          />
        </v-col>
      </v-row>
    
            </v-navigation-drawer>
    </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  <ConfirmationDialogInputAndFile
    v-if="dialogVisibleAddAttachment"
    :visible="dialogVisibleAddAttachment" 
    data-testid="add-file" 
    :cd-submit-btn="confirmationDialogInputAndFileSubmitBtn"
    :cd-input-placeholder="confirmationDialogInputAndFileInputPlaceholder"
    @close="closeDialog"
    :cd-title="confirmationDialogInputAndFileTitle"
    :item={}
    @proceedSubmit="reloadFiles"
  />
  <ConfirmationDialogInputAndLink
    v-if="dialogVisibleAddLink"
    :visible="dialogVisibleAddLink" 
    data-testid="add-link" 
    :cd-submit-btn="confirmationDialogInputAndLinkSubmitBtn"
    :cd-input-placeholder="confirmationDialogInputAndLinkInputPlaceholder"
    @close="closeDialog"
    :cd-title="confirmationDialogInputAndLinkTitle"
    :item={}
    @proceedSubmit="reloadFiles"
  />
  </nav>
</template>

<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import AddContentInHub from './AddContentInHub'
import ConfirmationDialogInputAndFile from './ConfirmationDialogInputAndFile'
import ConfirmationDialogInputAndLink from './ConfirmationDialogInputAndLink'
import i18n from '../plugins/i18n'

export default {
    components: {
     AddContentInHub,
     ConfirmationDialogInputAndFile,
     ConfirmationDialogInputAndLink
  },
  mixins: [repeatedMethodsMixin],
  props: {
    visible: Boolean,
    id: {
      type: Number,
      default: 0
    },
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      drawer: true,
      dialogVisibleAddAttachment: false,
      dialogVisibleAddLink: false,
      confirmationDialogInputAndFileTitle: i18n.t('attachFile'), 
      confirmationDialogInputAndFileSubmitBtn: i18n.t("add"),
      confirmationDialogInputAndFileInputPlaceholder: i18n.t("inputText"),
      confirmationDialogInputAndLinkTitle: i18n.t('attachLink'), 
      confirmationDialogInputAndLinkSubmitBtn: i18n.t("add"),
      confirmationDialogInputAndLinkInputPlaceholder: i18n.t("inputText")
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
         
      }
    }
  },
    methods: {
        addActivites(){
          this.$router.push({path: '/hub/'+this.$route.params.id+'/add-activities'})
        },
        addAttachment(){
          this.dialogVisibleAddAttachment=true
        },
        addLink(){
          this.dialogVisibleAddLink = true
        },
        closeDialog() {
            this.$emit('close')
        },
        reloadFiles(action)
        { 
          this.$emit('proceedSubmit', action)

        }        
        
    },
}
</script>